import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

//Set break
export const agentBreakStart = () => {
  return {
    type: actionTypes.AGENT_BREAK_START,
  };
};

export const agentBreakFail = (error) => {
  return {
    type: actionTypes.AGENT_BREAK_FAIL,
    error: error,
  };
};

export const agentBreakSuccess = (breakReasons) => {
  return {
    type: actionTypes.AGENT_BREAK_SUCCESS,
    breakReasons: breakReasons,
  };
};

export const agentBreak = (agentId, breakState, reason) => {
  return (dispatch) => {
    dispatch(agentBreakStart());
    let api = 'CTI_PAUSE';
    if (breakState === 'READY') {
      api = 'CTI_READY';
    } else {
      ctiRequest['CTI_PAUSE'].state = breakState;
      ctiRequest['CTI_PAUSE'].reason = reason;
    }
    ctiRequest[api].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest[api].ip = window.clientIP;
    axios
      .post('/', ctiRequest[api])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(agentBreakSuccess(result.data.response.break_reasons));
        } else {
          dispatch(agentBreakFail(result.data.response.reason));
          notify(breakState + ' Error: ' + result.data.response.reason, 'agent-break');
        }
      })
      .catch((err) => {
        console.log(err);
        notify(breakState + ' Error', 'agent-break');
        dispatch(agentBreakFail(err));
      });
  };
};
